import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { getData } from "../../../webService/webService";
import { useDispatch } from "react-redux";
import { setAllCertificate } from "../../../redux/slices/CertificateSlice";
import { setClientBasicandAdvance } from "../../../redux/slices/ReviewerSlice";

const ReviewerClientFilter = () => {
  const dispatch = useDispatch();
  const scheme_session = localStorage.getItem("scheme");
  const accessToken = localStorage.getItem("Token");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [limit, setlimit] = useState("");
  const [statusType, setstatusType] = useState("");
  const handleStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    if (endDate && endDate < selectedStartDate) {
      setEndDate("");
    }
    setStartDate(selectedStartDate);
  };
  const handlestatusTypeChange = (event) => {
    setstatusType(event.target.value);
  };
  const handleEndDateChange = (e) => {
    const selectedEndDate = e.target.value;
    if (startDate && startDate > selectedEndDate) {
      setStartDate("");
    }
    setEndDate(selectedEndDate);
  };
  const ClientBasicandadvance = () => {
    const params = {
      scheme: scheme_session === "HRA" ? "HRA" : "CB",
      page: 1,
      limit: limit,
      statusstartdate: startDate,
      statusenddate: endDate,
      statustype: statusType,
    };
    getData("clients/client/basic/advanced/all", params, accessToken)
      .then((res) => {
        dispatch(setClientBasicandAdvance(res.data));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const handleSearch = () => {
    ClientBasicandadvance();
  };

  return (
    <div
      style={{
        width: "100%",
        justifyContent: "between",
        display: "flex",
        margin: "10px 0px",
        alignItems: "center",
      }}
    >
      <TextField
        style={{ width: "30%" }}
        size="small"
        label="Start Date"
        type="date"
        className="m-2"
        value={startDate}
        onChange={handleStartDateChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        style={{ width: "30%" }}
        size="small"
        label="End Date"
        type="date"
        className="m-2"
        value={endDate}
        onChange={handleEndDateChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <FormControl
        style={{ width: "12%" }}
        variant="outlined"
        className="m-2"
        size="small"
      >
        <InputLabel id="Status">Status</InputLabel>
        <Select
          labelId="Status"
          id="Status"
          value={statusType}
          onChange={handlestatusTypeChange}
          label="Status"
        >
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="client details filled">
            Client Details Filled
          </MenuItem>
          <MenuItem value="reviewer assigned">Reviewer Assigned</MenuItem>
          <MenuItem value="need revision">Need Revision</MenuItem>
          <MenuItem value="approved">Approved</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
          <MenuItem value="auditor assigned">Auditor Assigned</MenuItem>
          <MenuItem value="technical review completed">
            Technical Review Completed
          </MenuItem>
          {/* <MenuItem value="certificate completed">
            Certificate Completed
          </MenuItem> */}
        </Select>
      </FormControl>
      <TextField
        style={{ width: "25%" }}
        size="small"
        label="Limit"
        className="m-2"
        type="number"
        onChange={(e) => setlimit(e.target.value)}
        InputLabelProps={{
          shrink: true,
        }}
      />

      <Button
        style={{ width: "15%" }}
        className="btn-green m-2"
        onClick={handleSearch}
      >
        Search
      </Button>
    </div>
  );
};

export default ReviewerClientFilter;
